import React from 'react';
import PropTypes from 'prop-types';
import './button.css';

/* Button — the storefront's `.sf-btn`.

   It renders an <a> when given an `href`, and the CSS accounts for that: the
   token bridge sets link colour with `:where(a)` precisely so a button written as
   a link still takes its own colour rule. Do not simplify that selector. */
export default function Button({
  variant,
  size,
  icon: Icon,
  iconRight,
  href,
  type,
  className,
  children,
  ...rest
}) {
  const classes = [
    'sf-btn',
    `sf-btn-${variant}`,
    size === 'sm' ? 'sf-btn-sm' : '',
    className,
  ].filter(Boolean).join(' ');

  const glyph = Icon ? <Icon aria-hidden="true" /> : null;

  const body = (
    <>
      {!iconRight && glyph}
      {children}
      {iconRight && glyph}
    </>
  );

  if (href) {
    return <a className={classes} href={href} {...rest}>{body}</a>;
  }
  return <button className={classes} type={type} {...rest}>{body}</button>;
}

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'ghost', 'white']),
  size: PropTypes.oneOf(['md', 'sm']),
  /** A lucide icon component, drawn at 15px on the leading edge. */
  icon: PropTypes.elementType,
  /** Move the icon to the trailing edge. */
  iconRight: PropTypes.bool,
  /** Renders an <a> instead of a <button>. */
  href: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

Button.defaultProps = {
  variant: 'primary',
  size: 'md',
  type: 'button',
};
